<template>

<div id="app" :class="{'is-desktop': window.is.desktop, 'is-tablet': window.is.tablet, 'is-mobile': window.is.mobile}">

	<com-head />

	<com-body class="app-body">

		<router-view />

	</com-body>

	<com-foot />

	<com-modals />
    <com-photos />

</div>

</template>

<script>

import comHead from './components/Head'
import comBody from './components/Body'
import comFoot from './components/Foot'
import comModals from './components/modal/Include'
import comPhotos from './components/photos/Include'

export default {

	components: {

		'com-head': comHead,
		'com-body': comBody,
		'com-foot': comFoot,
		'com-modals': comModals,
		'com-photos': comPhotos

	}

}

</script>

<style>

#app {
	width: 100%;
	min-height: 100vh;
	overflow: hidden;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	flex-grow: 1;
}

#app.is-loading {
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-image: url(~@/assets/app.load.gif);
}

#app > .app-body {
	opacity: 1;
	transition: opacity 100ms linear;
}

#app.is-loading > .app-body {
	opacity: 0.5;
}

:root {
	--color-yellow: #fcbe00;
	--color-yellow-dark: #f8ac00;
	--color-green-light: #a1e0a3;
	--color-green: #83ba84;
	--color-green-dark: #66a268;
	--color-red-light: #e0a1a1;
	--color-red: #b96060;
	--color-red-dark: #9a4f4f;
	--color-blue-light: #00afd4;
	--color-blue-dark: #1e83a0;
    --color-grey-lightest: #f5f5f5;
	--color-grey-light: #e5e5e5;
	--color-grey-highlight: #cccccc;
	--color-grey: #999999;
	--color-grey-dark: #222531;
	--color-band-0: #00afd4;
    --color-band-1: #cd8032;
	--color-band-2: #a8a7a2;
	--color-band-3: #ffc600;
    --color-brand-twitter: #00acee;
    --color-brand-facebook: #3b5998;
    --color-brand-instagram: #3f729b;
    --color-brand-linkedin: #0e76a8;
    --color-brand-hygiene: #d7e459;
    --color-brand-tiktok: #69C9D0;
    --color-brand-pinterest: #c8232c;
}

</style>